// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Spice from "@greenlabs/ppx-spice/src/rescript/Spice.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Js_json from "@rescript/std/lib/es6/js_json.js";
import * as Nullable from "../Nullable.bs.js";
import * as Atom_Label from "../design-system/atom/Atom_Label.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Float from "@rescript/std/lib/es6/belt_Float.js";
import * as Util_Array from "../util/Util_Array.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_Common from "../type/Type_Common.bs.js";
import * as Type_String from "../type/Type_String.bs.js";
import * as Type_Teaser from "../type/Type_Teaser.bs.js";
import * as Binding_Date from "../binding/Binding_Date.bs.js";
import * as Type_GuideTv from "../type/Type_GuideTv.bs.js";
import * as Type_Sticker from "../type/Type_Sticker.bs.js";
import * as $$Date from "@artegeie/date";

var _map = {"CONTACT_NAME":"CONTACT_NAME","CONTACT_MAIL":"CONTACT_MAIL","CONTACT_PHONE":"CONTACT_PHONE","RELEASE_URL":"RELEASE_URL","RELEASE_LABEL":"RELEASE_LABEL"};

function contactCodeToJs(param) {
  return param;
}

function contactCodeFromJs(param) {
  return _map[param];
}

function broadcastOnline_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ]]));
}

function broadcastOnline_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "label"), null));
  if (label.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              label: label._0
            }
          };
  }
  var e = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function broadcast_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "id",
                    false,
                    Spice.stringToJson(v.id)
                  ],
                  [
                    "title",
                    false,
                    Spice.stringToJson(v.title)
                  ],
                  [
                    "subtitle",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.subtitle)
                  ],
                  [
                    "shortDescription",
                    false,
                    Spice.stringToJson(v.shortDescription)
                  ],
                  [
                    "image",
                    false,
                    Spice.stringToJson(v.image)
                  ],
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ],
                  [
                    "schedule",
                    false,
                    Spice.stringToJson(v.schedule)
                  ],
                  [
                    "presseCategory",
                    true,
                    Spice.optionToJson(Spice.stringToJson, v.presseCategory)
                  ],
                  [
                    "highlighted",
                    false,
                    Spice.boolToJson(v.highlighted)
                  ],
                  [
                    "online",
                    false,
                    Nullable.t_encode(broadcastOnline_encode, v.online)
                  ],
                  [
                    "downloadUrl",
                    false,
                    Spice.stringToJson(v.downloadUrl)
                  ]
                ]));
}

function broadcast_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var title = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var subtitle = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subtitle"), null));
      if (subtitle.TAG === /* Ok */0) {
        var shortDescription = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shortDescription"), null));
        if (shortDescription.TAG === /* Ok */0) {
          var image = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
          if (image.TAG === /* Ok */0) {
            var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */0) {
              var schedule = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedule"), null));
              if (schedule.TAG === /* Ok */0) {
                var presseCategory = Spice.optionFromJson(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "presseCategory"), null));
                if (presseCategory.TAG === /* Ok */0) {
                  var highlighted = Spice.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "highlighted"), null));
                  if (highlighted.TAG === /* Ok */0) {
                    var online = Nullable.t_decode(broadcastOnline_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "online"), null));
                    if (online.TAG === /* Ok */0) {
                      var downloadUrl = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "downloadUrl"), null));
                      if (downloadUrl.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  id: id._0,
                                  title: title._0,
                                  subtitle: subtitle._0,
                                  shortDescription: shortDescription._0,
                                  image: image._0,
                                  url: url._0,
                                  schedule: schedule._0,
                                  presseCategory: presseCategory._0,
                                  highlighted: highlighted._0,
                                  online: online._0,
                                  downloadUrl: downloadUrl._0
                                }
                              };
                      }
                      var e = downloadUrl._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".downloadUrl" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = online._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".online" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = highlighted._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".highlighted" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = presseCategory._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".presseCategory" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = schedule._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".schedule" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = url._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".url" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = image._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".image" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = shortDescription._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".shortDescription" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = subtitle._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".subtitle" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function formatBroadcastDates(timeReference, nextBroadcastDateFormater, broadcastDates) {
  return Belt_Option.map(broadcastDates, (function (broadcastDates) {
                return Belt_Array.reduce(broadcastDates, [], (function (accumulator, broadcastDate) {
                              var date = new Date(broadcastDate);
                              var isFuture = $$Date.isAfter(date, timeReference);
                              if (!isFuture) {
                                return accumulator;
                              }
                              var dateFormat = Curry._1(Type_String.Teaser.BroadcastDate.make, Curry._1(nextBroadcastDateFormater, date));
                              return Belt_Array.concat(accumulator, [dateFormat]);
                            }));
              }));
}

function getAvailabilitySticker(timeReference, dateFormater, availability) {
  var __x = (availability == null) ? undefined : Caml_option.some(availability);
  return Belt_Option.map(Belt_Option.flatMap(__x, (function (param) {
                    var start = new Date(param.start);
                    if ($$Date.isAfter(start, timeReference)) {
                      return {
                              type_: param.type,
                              start: start
                            };
                    }
                    
                  })), dateFormater);
}

function getAvailabilityLabel(timeReference, betweenDatesFormater, start, end_) {
  var start$1 = new Date(start);
  var end_$1 = new Date(end_);
  var isBetween = $$Date.isBetween(start$1, end_$1, timeReference);
  var args = isBetween ? ({
        start: start$1,
        end_: end_$1
      }) : undefined;
  return Belt_Option.map(args, betweenDatesFormater);
}

function addToStickers(availabilitySticker, stickers, availability) {
  var type_ = availability !== undefined ? availability.type : undefined;
  return Belt_Option.getWithDefault(Belt_Option.map(availabilitySticker, (function (text) {
                    var match = Type_String.NotEmpty.make(text);
                    if (match === undefined) {
                      return stickers;
                    }
                    var text$1 = Caml_option.valFromOption(match);
                    if (type_ !== undefined && (type_ === "LIVESTREAM_WEB" || type_ === "LIVESTREAM_TV")) {
                      return Type_Sticker.updateTopLeft(stickers, {
                                  NAME: "Livestream",
                                  VAL: text$1
                                });
                    } else {
                      return Type_Sticker.updateTopLeft(stickers, {
                                  NAME: "AvailableOn",
                                  VAL: text$1
                                });
                    }
                  })), stickers);
}

function addAvailabilitySticker(timeReference, teaserKind, dateFormater, availability, stickers) {
  var match = Type_Teaser.Kind.view(teaserKind);
  var match$1 = stickers.topLeft;
  if (match === "Standard" && match$1 === undefined) {
    return addToStickers(getAvailabilitySticker(timeReference, dateFormater, availability), stickers, (availability == null) ? undefined : Caml_option.some(availability));
  } else {
    return stickers;
  }
}

function parseCodeLabels(codeLabels) {
  return Belt_Option.getWithDefault(Belt_Option.map((codeLabels == null) ? undefined : Caml_option.some(codeLabels), (function (audioVersions) {
                    return Util_Array.catOption(Belt_Array.map(audioVersions, (function (audioVersion) {
                                      return Belt_Option.map(Type_Common.audioVersionCodeFromJs(audioVersion.code), (function (code) {
                                                    return {
                                                            code: code,
                                                            label: audioVersion.label
                                                          };
                                                  }));
                                    })));
                  })), []);
}

function toDsBroadcast(broadcast) {
  var makeBroadcastOnline = function (online) {
    return {
            label: online.label
          };
  };
  return {
          id: broadcast.id,
          title: Curry._1(Type_String.Teaser.Title.make, broadcast.title),
          subtitle: Belt_Option.mapWithDefault(broadcast.subtitle, Curry._1(Type_String.Teaser.Subtitle.make, ""), Type_String.Teaser.Subtitle.make),
          shortDescription: broadcast.shortDescription,
          image: Type_Teaser.makeResolution(broadcast.image, 1920, 1080),
          url: broadcast.url,
          schedule: broadcast.schedule,
          presseCategory: Belt_Option.getWithDefault(broadcast.presseCategory, ""),
          sticker: broadcast.highlighted ? /* Highlight */0 : undefined,
          online: Belt_Option.map(Caml_option.nullable_to_opt(broadcast.online), makeBroadcastOnline),
          downloadUrl: broadcast.downloadUrl
        };
}

function toDsTeaser(teaser, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, firstBroadcastLabel, page) {
  var firstBroadcast = teaser.firstBroadcast;
  var durationLabel = Curry._1(Type_String.Teaser.DurationLabel.makeFromNullable, teaser.durationLabel);
  var durationStickerLabel = !(firstBroadcast == null) && firstBroadcast ? Curry._1(Type_String.Teaser.DurationLabel.make, firstBroadcastLabel) : durationLabel;
  var stickers = Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(teaser.stickers), Type_Sticker.makeFromCommonStickers), Type_Sticker.empty);
  var teaserKind = Type_Teaser.Kind.fromStickers(stickers);
  var stickers$1 = addAvailabilitySticker(timeReference, teaserKind, dateFormater, teaser.availability, Type_Teaser.Helper.addDurationSticker(durationStickerLabel, teaserKind, stickers));
  var dsId = Curry._1(Type_String.Teaser.DsId.make, teaser.id);
  var audioVersions = parseCodeLabels(teaser.audioVersions);
  var technicalInformations = parseCodeLabels(teaser.displayTechnicalInformations);
  var url = teaser.url;
  return {
          audioVersions: page ? undefined : Belt_Array.concat(audioVersions, technicalInformations),
          availability: Belt_Option.map(Caml_option.nullable_to_opt(teaser.availability), (function (param) {
                  var start = param.start;
                  return {
                          type_: param.type,
                          label: getAvailabilityLabel(timeReference, betweenDatesFormater, start, Belt_Option.getWithDefault(Caml_option.nullable_to_opt(param.end), "")),
                          start: start,
                          upcomingDate: param.upcomingDate
                        };
                })),
          broadcastDates: formatBroadcastDates(timeReference, nextBroadcastDateFormater, Caml_option.nullable_to_opt(teaser.broadcastDates)),
          callToAction: undefined,
          parentPage: undefined,
          credits: Caml_option.nullable_to_opt(teaser.credits),
          description: Curry._1(Type_String.Teaser.Description.makeFromNullable, teaser.teaserText),
          dsId: dsId,
          duration: Type_Common.jsMinDurationToDuration(teaser.duration),
          durationLabel: durationLabel,
          favoriteStatus: /* NotAvailable */0,
          href: (url == null) ? Type_String.Href.empty : Curry._1(Type_String.Href.make, url),
          geoblocking: undefined,
          id: Curry._1(Type_String.Teaser.Id.make, teaser.id),
          imageSrc: [{
              url: Curry._1(Type_String.Href.make, teaser.image),
              w: 720,
              h: 406
            }],
          key: Type_Teaser.Helper.makeKey(undefined, dsId),
          kind: Type_Teaser.Kind.standard,
          partners: undefined,
          program: {
            clip: undefined,
            description: Caml_option.nullable_to_opt(teaser.fullDescription),
            firstBroadcastDate: undefined,
            genre: Belt_Option.map(Caml_option.nullable_to_opt(teaser.genre), (function (param) {
                    return {
                            label: Curry._1(Type_String.Program.Genre.Label.make, param.label),
                            url: Curry._1(Type_String.Program.Genre.Url.makeFromNullable, param.url)
                          };
                  })),
            id: Curry._1(Type_String.Program.Id.make, teaser.id),
            kind: "TRAILER",
            shortDescription: Caml_option.nullable_to_opt(teaser.shortDescription),
            trailer: undefined
          },
          progression: Belt_Option.getWithDefault(undefined, Type_Common.Progression.noProgression),
          shopUrl: undefined,
          stickers: stickers$1,
          subtitle: Belt_Option.map(Caml_option.nullable_to_opt(teaser.subtitle), (function (subtitle) {
                  return {
                          TAG: /* Normal */0,
                          _0: Curry._1(Type_String.Teaser.Subtitle.make, subtitle)
                        };
                })),
          title: Belt_Option.map(Caml_option.nullable_to_opt(teaser.title), (function (title) {
                  return {
                          TAG: /* Displayed */0,
                          _0: Curry._1(Type_String.Teaser.Title.make, title)
                        };
                })),
          trackingPixel: undefined,
          hoverBehavior: /* Normal */1
        };
}

function makePresseMetas(contactLabel, program) {
  var contacts = program.press;
  if (contacts == null) {
    return [];
  } else {
    return [{
              label: contactLabel,
              value: {
                TAG: /* MultiString */3,
                _0: Util_Array.catOption(Belt_Array.keepMap(contacts, (function (contact) {
                            return Belt_Option.map(contactCodeFromJs(contact.code), (function (code) {
                                          if (code === "RELEASE_LABEL" || code === "RELEASE_URL") {
                                            return ;
                                          } else {
                                            return contact.label;
                                          }
                                        }));
                          })))
              }
            }];
  }
}

function recommandationsToDsZone(recommendations, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, firstBroadcastLabel, page) {
  var link_url = Caml_option.nullable_to_opt(recommendations.rcUrl);
  var link_title = recommendations.rcTitle;
  var link = {
    url: link_url,
    title: link_title
  };
  return {
          id: recommendations.rcId,
          link: link,
          title: {
            TAG: /* Displayed */0,
            _0: recommendations.rcTitle
          },
          itemTitle: /* Normal */0,
          description: undefined,
          itemTemplate: /* PlayNext */12,
          theme: {
            NAME: "PlayNext",
            VAL: /* WithoutSwitch */1
          },
          data: Belt_Array.map(recommendations.teasers, (function (teaser) {
                  return toDsTeaser(teaser, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, firstBroadcastLabel, page);
                })),
          nextPage: undefined,
          lastPage: undefined,
          totalPagesCount: undefined,
          slug: undefined,
          code: /* NotRecognized */2
        };
}

function fileToDownloadElement(file) {
  return {
          title: Curry._1(Type_String.Teaser.Title.make, file.title),
          subtitle: Curry._1(Type_String.Teaser.Subtitle.make, file.description),
          href: file.download,
          imageSrc: Type_Teaser.makeResolution(file.url, 1920, 1080),
          id: file.id
        };
}

function filesToDownloadElements(__x) {
  return Belt_Array.map(__x, fileToDownloadElement);
}

function getLabelFromCode(program, target) {
  return Belt_Option.flatMap(Caml_option.nullable_to_opt(program.press), (function (contacts) {
                return Belt_Array.reduce(contacts, undefined, (function (acc, contact) {
                              var match = contactCodeFromJs(contact.code);
                              if (acc !== undefined || !(match !== undefined && match === target)) {
                                return acc;
                              } else {
                                return contact.label;
                              }
                            }));
              }));
}

function programToCtas(program, firstBroadcastLabel) {
  var releaseUrl = getLabelFromCode(program, "RELEASE_URL");
  var releaseLabel = getLabelFromCode(program, "RELEASE_LABEL");
  var downloadButton = releaseUrl !== undefined && releaseLabel !== undefined ? ({
        label: releaseLabel,
        kind: {
          TAG: /* Href */0,
          _0: Curry._1(Type_String.Href.make, releaseUrl),
          _1: {
            TAG: /* Slider */19,
            _0: /* DownloadAll */2
          }
        },
        identifier: "pressemappeDownloadLink"
      }) : undefined;
  var match = program.firstBroadcast;
  var firstBroadcastButton = !(match == null) && match ? ({
        label: firstBroadcastLabel,
        kind: {
          TAG: /* Info */2,
          _0: Atom_Label.Atom_Label_Ds.outline
        },
        identifier: "ErstausstrahlungLabel"
      }) : undefined;
  return Util_Array.NonEmpty.makeFromArray(Util_Array.catOption([
                  downloadButton,
                  firstBroadcastButton
                ]));
}

function labels_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "download_all",
                    false,
                    Spice.stringToJson(v.download_all)
                  ],
                  [
                    "images",
                    false,
                    Spice.stringToJson(v.images)
                  ],
                  [
                    "highlight",
                    false,
                    Spice.stringToJson(v.highlight)
                  ]
                ]));
}

function labels_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var download_all = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_all"), null));
  if (download_all.TAG === /* Ok */0) {
    var images = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "images"), null));
    if (images.TAG === /* Ok */0) {
      var highlight = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "highlight"), null));
      if (highlight.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  download_all: download_all._0,
                  images: images._0,
                  highlight: highlight._0
                }
              };
      }
      var e = highlight._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".highlight" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = images._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".images" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = download_all._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".download_all" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function code_encode(v) {
  switch (v) {
    case /* Zip */0 :
        return "zip";
    case /* Xml */1 :
        return "xml";
    case /* Doc */2 :
        return "doc";
    
  }
}

function code_decode(v) {
  var str = Js_json.classify(v);
  if (typeof str === "number") {
    return Spice.error(undefined, "Not a JSONString", v);
  }
  if (str.TAG !== /* JSONString */0) {
    return Spice.error(undefined, "Not a JSONString", v);
  }
  var str$1 = str._0;
  if ("zip" === str$1) {
    return {
            TAG: /* Ok */0,
            _0: /* Zip */0
          };
  } else if ("xml" === str$1) {
    return {
            TAG: /* Ok */0,
            _0: /* Xml */1
          };
  } else if ("doc" === str$1) {
    return {
            TAG: /* Ok */0,
            _0: /* Doc */2
          };
  } else {
    return Spice.error(undefined, "Not matched", v);
  }
}

function types_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "code",
                    false,
                    Spice.stringToJson(v.code)
                  ],
                  [
                    "label",
                    false,
                    Spice.stringToJson(v.label)
                  ],
                  [
                    "ariaLabel",
                    false,
                    Spice.stringToJson(v.ariaLabel)
                  ]
                ]));
}

function types_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var label = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var ariaLabel = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ariaLabel"), null));
      if (ariaLabel.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  code: code._0,
                  label: label._0,
                  ariaLabel: ariaLabel._0
                }
              };
      }
      var e = ariaLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".ariaLabel" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function weekDownload_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "pattern",
                    false,
                    Spice.stringToJson(v.pattern)
                  ],
                  [
                    "types",
                    false,
                    Spice.arrayToJson(types_encode, v.types)
                  ]
                ]));
}

function weekDownload_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pattern = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pattern"), null));
  if (pattern.TAG === /* Ok */0) {
    var types = Spice.arrayFromJson(types_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "types"), null));
    if (types.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                pattern: pattern._0,
                types: types._0
              }
            };
    }
    var e = types._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".types" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = pattern._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pattern" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "day",
                    false,
                    Spice.stringToJson(v.day)
                  ],
                  [
                    "labels",
                    false,
                    labels_encode(v.labels)
                  ],
                  [
                    "weekDownload",
                    false,
                    weekDownload_encode(v.weekDownload)
                  ],
                  [
                    "programming",
                    false,
                    Spice.arrayToJson(broadcast_encode, v.programming)
                  ]
                ]));
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var day = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "day"), null));
  if (day.TAG === /* Ok */0) {
    var labels = labels_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labels"), null));
    if (labels.TAG === /* Ok */0) {
      var weekDownload = weekDownload_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "weekDownload"), null));
      if (weekDownload.TAG === /* Ok */0) {
        var programming = Spice.arrayFromJson(broadcast_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "programming"), null));
        if (programming.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    day: day._0,
                    labels: labels._0,
                    weekDownload: weekDownload._0,
                    programming: programming._0
                  }
                };
        }
        var e = programming._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".programming" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = weekDownload._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".weekDownload" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = labels._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labels" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = day._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".day" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function filterByCode(types, code) {
  return Util_Array.getFirstElement(Belt_Array.keepMap(types, (function (_type) {
                    var result = code_decode(_type.code);
                    if (result.TAG === /* Ok */0 && result._0 === code) {
                      return _type;
                    }
                    
                  })));
}

function makeDownloadUrl(pattern, codeType, weekNumber) {
  return pattern.replace("%WEEKNUMBER%", String(weekNumber)).replace("%TYPE%", codeType);
}

function makeDisplayArrows(index) {
  var match = index === 0;
  var match$1 = index === 7;
  if (match) {
    if (match$1) {
      return {
              next: /* Hidden */0,
              previous: /* Hidden */0
            };
    } else {
      return {
              next: /* Visible */1,
              previous: /* Hidden */0
            };
    }
  } else if (match$1) {
    return {
            next: /* Hidden */0,
            previous: /* Visible */1
          };
  } else {
    return {
            next: /* Visible */1,
            previous: /* Visible */1
          };
  }
}

function makeDaysRange(startOfWeek, selectedDate) {
  var startOfWeek$1 = Type_GuideTv.makeDateWithoutTime(startOfWeek);
  var selectedDate$1 = Type_GuideTv.makeDateWithoutTime(selectedDate);
  var daysRange = Binding_Date.range(startOfWeek$1, 7);
  return Belt_Array.map(daysRange, (function (date) {
                var status = $$Date.isSameDay(date, selectedDate$1) ? /* Current */0 : /* Default */1;
                return {
                        date: date,
                        status: status
                      };
              }));
}

function makeWeekRangeItems(currentDate, selectedDate) {
  var startOfWeek = $$Date.startOfWeek(currentDate, /* De */1, Binding_Date.WeekStartsOn.saturday);
  var firstWeekNumber = $$Date.getWeek(startOfWeek, /* De */1, Binding_Date.WeekStartsOn.saturday);
  var currentWeekNumber = $$Date.getWeek(selectedDate, /* De */1, Binding_Date.WeekStartsOn.saturday);
  var lastWeekNumber = firstWeekNumber + 7 | 0;
  var weekItems = Belt_Array.mapWithIndex(Belt_Array.range(firstWeekNumber + 1 | 0, lastWeekNumber), (function (index, number) {
          var startOfWeek$1 = $$Date.addWeeks(startOfWeek, index + 1 | 0);
          return {
                  displayArrows: makeDisplayArrows(index + 1 | 0),
                  rangeSelectDay: makeDaysRange(startOfWeek$1, selectedDate),
                  weekNumber: number,
                  weekIndex: index + 2 | 0,
                  status: number === currentWeekNumber ? /* Current */0 : /* Default */1,
                  startOfWeek: startOfWeek$1
                };
        }));
  return Util_Array.NonEmpty.make(weekItems, {
              displayArrows: makeDisplayArrows(0),
              rangeSelectDay: makeDaysRange(startOfWeek, selectedDate),
              weekNumber: firstWeekNumber,
              weekIndex: 1,
              status: firstWeekNumber === currentWeekNumber ? /* Current */0 : /* Default */1,
              startOfWeek: startOfWeek
            });
}

function updateStatusIntoDayRange(rangeSelectDay, date) {
  return Belt_Array.map(rangeSelectDay, (function (day) {
                var status = $$Date.isSameDay(day.date, date) ? /* Current */0 : /* Default */1;
                return {
                        date: day.date,
                        status: status
                      };
              }));
}

function updateWeekRange(weekRange, selectWeekNumber) {
  return Util_Array.NonEmpty.map(weekRange, (function (week) {
                var status = week.weekNumber === selectWeekNumber ? /* Current */0 : /* Default */1;
                return {
                        displayArrows: week.displayArrows,
                        rangeSelectDay: week.rangeSelectDay,
                        weekNumber: week.weekNumber,
                        weekIndex: week.weekIndex,
                        status: status,
                        startOfWeek: week.startOfWeek
                      };
              }));
}

function getSelectWeekRange(weekRange, weekNumber, defaultWeek) {
  return Belt_Option.mapWithDefault(Util_Array.NonEmpty.find(weekRange, (function (week) {
                    return week.weekNumber === weekNumber;
                  })), defaultWeek, (function (week) {
                return {
                        displayArrows: week.displayArrows,
                        rangeSelectDay: week.rangeSelectDay,
                        weekNumber: week.weekNumber,
                        weekIndex: week.weekIndex,
                        status: /* Current */0,
                        startOfWeek: week.startOfWeek
                      };
              }));
}

function getHoursFromSchedule(schedule) {
  return Belt_Option.flatMap(Belt_Array.get(schedule.split(":"), 0), Belt_Float.fromString);
}

function getMinutesFromSchedule(schedule) {
  return Belt_Option.flatMap(Belt_Array.get(schedule.split(":"), 1), Belt_Float.fromString);
}

function filterBroadcastsByInterval(broadcasts, interval, date) {
  return Belt_Array.keep(broadcasts, (function (broadcast) {
                var hours = getHoursFromSchedule(broadcast.schedule);
                var minutes = getMinutesFromSchedule(broadcast.schedule);
                if (hours === undefined) {
                  return false;
                }
                if (minutes === undefined) {
                  return false;
                }
                var dateWithTime = Binding_Date.updateTime(date, hours, minutes);
                var dateInterval = Type_GuideTv.makeDateFromTimeInterval(dateWithTime, interval);
                return $$Date.isWithinInterval(dateWithTime, dateInterval);
              }));
}

function toInterval(string) {
  if (string === "#evening") {
    return /* Evening */1;
  } else {
    return /* AllDay */0;
  }
}

function setInitialeState(selectedDate, weekItems) {
  var selectWeek = $$Date.getWeek(selectedDate, /* De */1, Binding_Date.WeekStartsOn.saturday);
  var selectedWeekIntoWeekItems = Util_Array.NonEmpty.find(weekItems, (function (item) {
          return item.weekNumber === selectWeek;
        }));
  return Belt_Option.getWithDefault(selectedWeekIntoWeekItems, Util_Array.NonEmpty.head(weekItems));
}

var Guide_eveningInterval = {
  start: {
    hour: 19,
    minute: 0
  },
  end: {
    hour: 23,
    minute: 59
  }
};

var Guide = {
  eveningInterval: Guide_eveningInterval,
  labels_encode: labels_encode,
  labels_decode: labels_decode,
  code_encode: code_encode,
  code_decode: code_decode,
  types_encode: types_encode,
  types_decode: types_decode,
  weekDownload_encode: weekDownload_encode,
  weekDownload_decode: weekDownload_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  filterByCode: filterByCode,
  makeDownloadUrl: makeDownloadUrl,
  numberOfDaysGap: 7,
  numberOfWeekGap: 7,
  makeDisplayArrows: makeDisplayArrows,
  makeDaysRange: makeDaysRange,
  makeWeekRangeItems: makeWeekRangeItems,
  updateStatusIntoDayRange: updateStatusIntoDayRange,
  updateWeekRange: updateWeekRange,
  getSelectWeekRange: getSelectWeekRange,
  getHoursFromSchedule: getHoursFromSchedule,
  getMinutesFromSchedule: getMinutesFromSchedule,
  filterBroadcastsByInterval: filterBroadcastsByInterval,
  toInterval: toInterval,
  setInitialeState: setInitialeState
};

export {
  contactCodeToJs ,
  contactCodeFromJs ,
  broadcastOnline_encode ,
  broadcastOnline_decode ,
  broadcast_encode ,
  broadcast_decode ,
  formatBroadcastDates ,
  getAvailabilitySticker ,
  getAvailabilityLabel ,
  addToStickers ,
  addAvailabilitySticker ,
  parseCodeLabels ,
  toDsBroadcast ,
  toDsTeaser ,
  makePresseMetas ,
  recommandationsToDsZone ,
  fileToDownloadElement ,
  filesToDownloadElements ,
  getLabelFromCode ,
  programToCtas ,
  Guide ,
}
/* Atom_Label Not a pure module */
